module.exports = __webpack_public_path__ + "media/images/front/premium_lp/logo_01-4efaed596adf847989ded73f0a3bda86.png";